<template>
  <div class="kt-portlet">
    <h3 class="kt-portlet__head-title my-5 pl-2">
      Assigned in Training Library:
    </h3>
    <v-card elevation="0">
      <v-card-text>
        <v-treeview open-all :items="items"></v-treeview>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
export default {
  name: 'AssignLibraryTreeView',
  data: () => ({
    items: [
      {
        id: 1,
        name: 'Curriculum Name',
        children: [
          {
            id: 1,
            name: 'Course Name',
            children: [
              {
                id: 1,
                name: 'Module Name',
                children: [
                  {
                    id: 1,
                    name: 'Series Name',
                  },
                ],
              },
            ],
          },
        ],
      },
    ],
  }),
};
</script>

<style scoped></style>
